export const baseURL = process.env.REACT_APP_BASE_URL;
export const secretKey = process.env.REACT_APP_SECRET_KEY;
export const projectName = process.env.REACT_APP_PROJECT_NAME || "";
